import _asyncToGenerator from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
import { _ as _objectSpread2 } from './_rollupPluginBabelHelpers-05128ded.js';
import React__default, { useLayoutEffect, useState, useEffect, useCallback, useMemo, useReducer } from 'react';
import { SendbirdSdkContext } from './withSendbird.js';
import cssVars from 'css-vars-ponyfill';
import { K } from './index.module-4f1cd64e.js';
import { U as USER_ACTIONS } from './actionTypes-ba87a2c9.js';
import SendbirdChat, { ConnectionHandler } from '@sendbird/chat';
import { u as uuidv4 } from './uuid-717930b4.js';
import { OpenChannelModule } from '@sendbird/chat/openChannel';
import { GroupChannelModule } from '@sendbird/chat/groupChannel';
import { i as isTextuallyNull } from './index-579ca9d7.js';
import { UIKitConfigProvider, useUIKitConfig } from '@sendbird/uikit-tools';
import { V as VoicePlayerProvider } from './index-fa5b2b8c.js';
import { VoiceRecorderProvider } from './VoiceRecorder/context.js';
import { L as LocalizationProvider } from './LocalizationContext-a82461b5.js';
import { M as MediaQueryProvider } from './MediaQueryContext-d6110905.js';
import { g as getStringSet } from './stringSet-b60e9529.js';
import { V as VOICE_RECORDER_DEFAULT_MAX, a as VOICE_RECORDER_DEFAULT_MIN } from './consts-fa6ab3c0.js';
import { g as getCaseResolvedReplyType, a as getCaseResolvedThreadReplySelectType } from './resolvedReplyType-9d00a3db.js';
import './utils/message/getOutgoingMessageState.js';
import './useSendbirdStateContext.js';
import './ui/Modal.js';
import 'react-dom';
import './index-a9101009.js';
import './ui/Button.js';
import './index-6420013c.js';
import 'prop-types';
import './ui/Icon.js';
import './ui/IconButton.js';
import './index-6add7940.js';
var isEmpty = function isEmpty(obj) {
  if (obj === null || obj === undefined) {
    return true;
  }
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
};
var useTheme = function useTheme(overrides) {
  useLayoutEffect(function () {
    if (!isEmpty(overrides)) {
      cssVars({
        variables: _objectSpread2(_objectSpread2({}, {
          '--sendbird-dark-primary-500': '#4d2aa6',
          '--sendbird-dark-primary-400': '#6440C4',
          '--sendbird-dark-primary-300': '#7B53EF',
          '--sendbird-dark-primary-200': '#9E8CF5',
          '--sendbird-dark-primary-100': '#E2DFFF',
          '--sendbird-dark-secondary-500': '#007A7A',
          '--sendbird-dark-secondary-400': '#189A8D',
          '--sendbird-dark-secondary-300': '#2EBA9F',
          '--sendbird-dark-secondary-200': '#6FD6BE',
          '--sendbird-dark-secondary-100': '#AEF2DC',
          '--sendbird-dark-information-100': '#b2d9ff',
          '--sendbird-dark-error-500': '#A30E2D',
          '--sendbird-dark-error-400': '#C11F41',
          '--sendbird-dark-error-300': '#E53157',
          '--sendbird-dark-error-200': '#FF6183',
          '--sendbird-dark-error-100': '#FFABBD',
          '--sendbird-dark-background-700': '#000000',
          '--sendbird-dark-background-600': '#161616',
          '--sendbird-dark-background-500': '#2C2C2C',
          '--sendbird-dark-background-400': '#393939',
          '--sendbird-dark-background-300': '#A8A8A8',
          '--sendbird-dark-background-200': '#D9D9D9',
          '--sendbird-dark-background-100': '#F0F0F0',
          '--sendbird-dark-background-50': '#FFFFFF',
          '--sendbird-dark-overlay': 'rgba(0, 0, 0, 0.32)',
          '--sendbird-dark-onlight-01': 'rgba(0, 0, 0, 0.88)',
          '--sendbird-dark-onlight-02': 'rgba(0, 0, 0, 0.50)',
          '--sendbird-dark-onlight-03': 'rgba(0, 0, 0, 0.38)',
          '--sendbird-dark-onlight-04': 'rgba(0, 0, 0, 0.12)',
          '--sendbird-dark-ondark-01': 'rgba(255, 255, 255, 0.88)',
          '--sendbird-dark-ondark-02': 'rgba(255, 255, 255, 0.50)',
          '--sendbird-dark-ondark-03': 'rgba(255, 255, 255, 0.38)',
          '--sendbird-dark-ondark-04': 'rgba(255, 255, 255, 0.12)',
          '--sendbird-dark-shadow-01': '0 1px 5px 0 rgba(33, 34, 66, 0.04), 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 2px 1px 0 rgba(0, 0, 0, 0.12)',
          '--sendbird-dark-shadow-02': '0 3px 5px -3px rgba(33, 34, 66, 0.04), 0 3px 14px 2px rgba(0, 0, 0, 0.08), 0 8px 10px 1px rgba(0, 0, 0, 0.12)',
          '--sendbird-dark-shadow-03': '0 6px 10px -5px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.08), 0 16px 24px 2px rgba(0, 0, 0, 0.12)',
          '--sendbird-dark-shadow-04': '0 9px 15px -7px rgba(0, 0, 0, 0.04), 0 9px 46px 8px rgba(0, 0, 0, 0.08), 0 24px 38px 3px rgba(0, 0, 0, 0.12)',
          '--sendbird-dark-shadow-message-input': '0 1px 5px 0 rgba(33, 34, 66, 0.12), 0 0 1px 0 rgba(33, 34, 66, 0.16), 0 2px 1px 0 rgba(33, 34, 66, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
          '--sendbird-light-primary-500': '#4d2aa6',
          '--sendbird-light-primary-400': '#6440C4',
          '--sendbird-light-primary-300': '#7B53EF',
          '--sendbird-light-primary-200': '#9E8CF5',
          '--sendbird-light-primary-100': '#E2DFFF',
          '--sendbird-light-secondary-500': '#007A7A',
          '--sendbird-light-secondary-400': '#189A8D',
          '--sendbird-light-secondary-300': '#2EBA9F',
          '--sendbird-light-secondary-200': '#6FD6BE',
          '--sendbird-light-secondary-100': '#AEF2DC',
          '--sendbird-light-information-100': '#b2d9ff',
          '--sendbird-light-error-500': '#A30E2D',
          '--sendbird-light-error-400': '#C11F41',
          '--sendbird-light-error-300': '#E53157',
          '--sendbird-light-error-200': '#FF6183',
          '--sendbird-light-error-100': '#FFABBD',
          '--sendbird-light-background-700': '#000000',
          '--sendbird-light-background-600': '#161616',
          '--sendbird-light-background-500': '#2C2C2C',
          '--sendbird-light-background-400': '#393939',
          '--sendbird-light-background-300': '#A8A8A8',
          '--sendbird-light-background-200': '#D9D9D9',
          '--sendbird-light-background-100': '#F0F0F0',
          '--sendbird-light-background-50': ' #FFFFFF',
          '--sendbird-light-overlay': 'rgba(0, 0, 0, 0.32)',
          '--sendbird-light-onlight-01': 'rgba(0, 0, 0, 0.88)',
          '--sendbird-light-onlight-02': 'rgba(0, 0, 0, 0.50)',
          '--sendbird-light-onlight-03': 'rgba(0, 0, 0, 0.38)',
          '--sendbird-light-onlight-04': 'rgba(0, 0, 0, 0.12)',
          '--sendbird-light-ondark-01': 'rgba(255, 255, 255, 0.88)',
          '--sendbird-light-ondark-02': 'rgba(255, 255, 255, 0.50)',
          '--sendbird-light-ondark-03': 'rgba(255, 255, 255, 0.38)',
          '--sendbird-light-ondark-04': 'rgba(255, 255, 255, 0.12)',
          '--sendbird-light-shadow-01': '0 1px 5px 0 rgba(33, 34, 66, 0.04), 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 2px 1px 0 rgba(0, 0, 0, 0.12)',
          '--sendbird-light-shadow-02': '0 3px 5px -3px rgba(33, 34, 66, 0.04), 0 3px 14px 2px rgba(0, 0, 0, 0.08), 0 8px 10px 1px rgba(0, 0, 0, 0.12)',
          '--sendbird-light-shadow-03': '0 6px 10px -5px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.08), 0 16px 24px 2px rgba(0, 0, 0, 0.12)',
          '--sendbird-light-shadow-04': '0 9px 15px -7px rgba(0, 0, 0, 0.04), 0 9px 46px 8px rgba(0, 0, 0, 0.08), 0 24px 38px 3px rgba(0, 0, 0, 0.12)',
          '--sendbird-light-shadow-message-input': '0 1px 5px 0 rgba(33, 34, 66, 0.12), 0 0 1px 0 rgba(33, 34, 66, 0.16), 0 2px 1px 0 rgba(33, 34, 66, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.12)'
        }), overrides)
      });
    }
  }, [overrides]);
};
var SDK_ACTIONS = {
  INIT_SDK: 'INIT_SDK',
  SET_SDK_LOADING: 'SET_SDK_LOADING',
  RESET_SDK: 'RESET_SDK',
  SDK_ERROR: 'SDK_ERROR'
};
var initialState$1 = {
  initialized: false,
  loading: false,
  sdk: {},
  error: false
};
function reducer$1(state, action) {
  return K(action).with({
    type: SDK_ACTIONS.SET_SDK_LOADING
  }, function (_ref) {
    var payload = _ref.payload;
    return _objectSpread2(_objectSpread2({}, state), {}, {
      initialized: false,
      loading: payload
    });
  }).with({
    type: SDK_ACTIONS.SDK_ERROR
  }, function () {
    return _objectSpread2(_objectSpread2({}, state), {}, {
      initialized: false,
      loading: false,
      error: true
    });
  }).with({
    type: SDK_ACTIONS.INIT_SDK
  }, function (_ref2) {
    var payload = _ref2.payload;
    return {
      sdk: payload,
      initialized: true,
      loading: false,
      error: false
    };
  }).with({
    type: SDK_ACTIONS.RESET_SDK
  }, function () {
    return initialState$1;
  }).otherwise(function () {
    return state;
  });
}
var initialState = {
  initialized: false,
  loading: false,
  user: {}
};
function reducer(state, action) {
  return K(action).with({
    type: USER_ACTIONS.INIT_USER
  }, function (_ref) {
    var payload = _ref.payload;
    return {
      initialized: true,
      loading: false,
      user: payload
    };
  }).with({
    type: USER_ACTIONS.RESET_USER
  }, function () {
    return initialState;
  }).with({
    type: USER_ACTIONS.UPDATE_USER_INFO
  }, function (_ref2) {
    var payload = _ref2.payload;
    return _objectSpread2(_objectSpread2({}, state), {}, {
      user: payload
    });
  }).otherwise(function () {
    return state;
  });
}
function useConnectionStatus(sdk, logger) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOnline = _useState2[0],
    setIsOnline = _useState2[1];
  useEffect(function () {
    var uniqueHandlerId = uuidv4();
    try {
      logger.warning('sdk changed', uniqueHandlerId);
      var handler = new ConnectionHandler();
      handler.onDisconnected = function () {
        setIsOnline(false);
        logger.warning('onDisconnected', {
          isOnline: isOnline
        });
      };
      handler.onReconnectStarted = function () {
        setIsOnline(false);
        logger.warning('onReconnectStarted', {
          isOnline: isOnline
        });
      };
      handler.onReconnectSucceeded = function () {
        setIsOnline(true);
        logger.warning('onReconnectSucceeded', {
          isOnline: isOnline
        });
      };
      handler.onReconnectFailed = function () {
        sdk.reconnect();
        logger.warning('onReconnectFailed');
      };
      logger.info('Added ConnectionHandler', uniqueHandlerId);
      // workaround -> addConnectionHandler invalidates session handler
      // provided through configureSession
      if (sdk !== null && sdk !== void 0 && sdk.addConnectionHandler) {
        sdk.addConnectionHandler(uniqueHandlerId, handler);
      }
    } catch (_unused) {
      //
    }
    return function () {
      try {
        sdk.removeConnectionHandler(uniqueHandlerId);
        logger.info('Removed ConnectionHandler', uniqueHandlerId);
      } catch (_unused2) {
        //
      }
    };
  }, [sdk]);
  useEffect(function () {
    var tryReconnect = function tryReconnect() {
      try {
        logger.warning('Try reconnecting SDK');
        if (sdk.connectionState !== 'OPEN') {
          // connection is not broken yet
          sdk.reconnect();
        }
      } catch (_unused3) {
        //
      }
    };
    // addEventListener version
    window.addEventListener('online', tryReconnect);
    return function () {
      window.removeEventListener('online', tryReconnect);
    };
  }, [sdk]);

  // add offline-class to body
  useEffect(function () {
    var body = document.querySelector('body');
    if (!isOnline) {
      try {
        body.classList.add('sendbird__offline');
        logger.info('Added class sendbird__offline to body');
      } catch (e) {
        //
      }
    } else {
      try {
        body.classList.remove('sendbird__offline');
        logger.info('Removed class sendbird__offline from body');
      } catch (e) {
        //
      }
    }
  }, [isOnline]);
  return isOnline;
}
function disconnectSdk(_x) {
  return _disconnectSdk.apply(this, arguments);
}
function _disconnectSdk() {
  _disconnectSdk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var sdkDispatcher, userDispatcher, sdk;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sdkDispatcher = _ref.sdkDispatcher, userDispatcher = _ref.userDispatcher, sdk = _ref.sdk;
          return _context.abrupt("return", new Promise(function (resolve) {
            sdkDispatcher({
              type: SDK_ACTIONS.SET_SDK_LOADING,
              payload: true
            });
            if (sdk !== null && sdk !== void 0 && sdk.disconnect) {
              sdk.disconnect().then(function () {
                sdkDispatcher({
                  type: SDK_ACTIONS.RESET_SDK
                });
                userDispatcher({
                  type: USER_ACTIONS.RESET_USER
                });
              }).finally(function () {
                resolve(true);
              });
            } else {
              resolve(true);
            }
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _disconnectSdk.apply(this, arguments);
}
var APP_VERSION_STRING = '3.6.2';
var INIT_SDK = SDK_ACTIONS.INIT_SDK,
  SET_SDK_LOADING = SDK_ACTIONS.SET_SDK_LOADING,
  RESET_SDK = SDK_ACTIONS.RESET_SDK,
  SDK_ERROR = SDK_ACTIONS.SDK_ERROR;
var INIT_USER = USER_ACTIONS.INIT_USER,
  UPDATE_USER_INFO = USER_ACTIONS.UPDATE_USER_INFO,
  RESET_USER = USER_ACTIONS.RESET_USER;
function getMissingParamError(_ref) {
  var userId = _ref.userId,
    appId = _ref.appId;
  return "SendbirdProvider | useConnect/setupConnection/Connection failed UserId: ".concat(userId, " or appId: ").concat(appId, " missing");
}
function getConnectSbError(error) {
  return "SendbirdProvider | useConnect/setupConnection/Connection failed. ".concat((error === null || error === void 0 ? void 0 : error.code) || '', " ").concat((error === null || error === void 0 ? void 0 : error.message) || '');
}
function setUpParams(_ref2) {
  var appId = _ref2.appId,
    customApiHost = _ref2.customApiHost,
    customWebSocketHost = _ref2.customWebSocketHost;
  var params = {
    appId: appId,
    modules: [new GroupChannelModule(), new OpenChannelModule()],
    newInstance: true
  };
  if (customApiHost) {
    params['customApiHost'] = customApiHost;
  }
  if (customWebSocketHost) {
    params['customWebSocketHost'] = customWebSocketHost;
  }
  var newSdk = SendbirdChat.init(params);
  return newSdk;
}

// Steps
// 1. Check if minimum userID/appID is provided
//  1.a. If not, throw error > !reject
//  1.b. If yes, continue
// 2. Set up params with custom host if provided
// 3. Set up session handler if provided
// 4. Set up version
// 5. Connect to Sendbird -> either using user ID or (user ID + access token)
// 6. If connected, connectCbSucess
//  6.a check if nickname is to be updated -> no > !resolve immediately
//  6.b check if nickname is to be updated -> yes > update nickname > !resolve
// 7. If not connected, connectCbError > !reject
function setUpConnection(_x2) {
  return _setUpConnection.apply(this, arguments);
}
function _setUpConnection() {
  _setUpConnection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
    var logger, sdkDispatcher, userDispatcher, initDashboardConfigs, userId, appId, customApiHost, customWebSocketHost, configureSession, nickname, profileUrl, accessToken;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          logger = _ref3.logger, sdkDispatcher = _ref3.sdkDispatcher, userDispatcher = _ref3.userDispatcher, initDashboardConfigs = _ref3.initDashboardConfigs, userId = _ref3.userId, appId = _ref3.appId, customApiHost = _ref3.customApiHost, customWebSocketHost = _ref3.customWebSocketHost, configureSession = _ref3.configureSession, nickname = _ref3.nickname, profileUrl = _ref3.profileUrl, accessToken = _ref3.accessToken;
          return _context3.abrupt("return", new Promise(function (resolve, reject) {
            var _logger$info;
            logger === null || logger === void 0 ? void 0 : (_logger$info = logger.info) === null || _logger$info === void 0 ? void 0 : _logger$info.call(logger, 'SendbirdProvider | useConnect/setupConnection/init', {
              userId: userId,
              appId: appId
            });
            sdkDispatcher({
              type: SET_SDK_LOADING,
              payload: true
            });
            if (userId && appId) {
              var _logger$info3, _logger$info8;
              var newSdk = setUpParams({
                appId: appId,
                customApiHost: customApiHost,
                customWebSocketHost: customWebSocketHost
              });
              if (configureSession && typeof configureSession === 'function') {
                var _logger$info2;
                var sessionHandler = configureSession(newSdk);
                logger === null || logger === void 0 ? void 0 : (_logger$info2 = logger.info) === null || _logger$info2 === void 0 ? void 0 : _logger$info2.call(logger, 'SendbirdProvider | useConnect/setupConnection/configureSession', sessionHandler);
                newSdk.setSessionHandler(sessionHandler);
              }
              logger === null || logger === void 0 ? void 0 : (_logger$info3 = logger.info) === null || _logger$info3 === void 0 ? void 0 : _logger$info3.call(logger, 'SendbirdProvider | useConnect/setupConnection/setVersion', {
                version: APP_VERSION_STRING
              });
              newSdk.addExtension('sb_uikit', APP_VERSION_STRING);
              var connectCbSucess = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(user) {
                  var _logger$info4, _logger$info6;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        logger === null || logger === void 0 ? void 0 : (_logger$info4 = logger.info) === null || _logger$info4 === void 0 ? void 0 : _logger$info4.call(logger, 'SendbirdProvider | useConnect/setupConnection/connectCbSucess', user);
                        sdkDispatcher({
                          type: INIT_SDK,
                          payload: newSdk
                        });
                        userDispatcher({
                          type: INIT_USER,
                          payload: user
                        });
                        initDashboardConfigs(newSdk).then(function (config) {
                          var _logger$info5;
                          logger === null || logger === void 0 ? void 0 : (_logger$info5 = logger.info) === null || _logger$info5 === void 0 ? void 0 : _logger$info5.call(logger, 'SendbirdProvider | useConnect/setupConnection/getUIKitConfiguration success', {
                            config: config
                          });
                        }).catch(function (error) {
                          var _logger$error;
                          logger === null || logger === void 0 ? void 0 : (_logger$error = logger.error) === null || _logger$error === void 0 ? void 0 : _logger$error.call(logger, 'SendbirdProvider | useConnect/setupConnection/getUIKitConfiguration failed', {
                            error: error
                          });
                        });

                        // use nickname/profileUrl if provided
                        // or set userID as nickname
                        if ((nickname !== user.nickname || profileUrl !== user.profileUrl) && !(isTextuallyNull(nickname) && isTextuallyNull(profileUrl))) {
                          logger === null || logger === void 0 ? void 0 : (_logger$info6 = logger.info) === null || _logger$info6 === void 0 ? void 0 : _logger$info6.call(logger, 'SendbirdProvider | useConnect/setupConnection/updateCurrentUserInfo', {
                            nickname: nickname,
                            profileUrl: profileUrl
                          });
                          newSdk.updateCurrentUserInfo({
                            nickname: nickname || user.nickname,
                            profileUrl: profileUrl || user.profileUrl
                          }).then(function (namedUser) {
                            var _logger$info7;
                            logger === null || logger === void 0 ? void 0 : (_logger$info7 = logger.info) === null || _logger$info7 === void 0 ? void 0 : _logger$info7.call(logger, 'SendbirdProvider | useConnect/setupConnection/updateCurrentUserInfo success', {
                              nickname: nickname,
                              profileUrl: profileUrl
                            });
                            userDispatcher({
                              type: UPDATE_USER_INFO,
                              payload: namedUser
                            });
                          }).finally(function () {
                            resolve();
                          });
                        } else {
                          resolve();
                        }
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function connectCbSucess(_x4) {
                  return _ref4.apply(this, arguments);
                };
              }();
              var connectCbError = function connectCbError(e) {
                var _logger$error2;
                var errorMessage = getConnectSbError(e);
                logger === null || logger === void 0 ? void 0 : (_logger$error2 = logger.error) === null || _logger$error2 === void 0 ? void 0 : _logger$error2.call(logger, errorMessage, {
                  e: e,
                  appId: appId,
                  userId: userId
                });
                sdkDispatcher({
                  type: RESET_SDK
                });
                userDispatcher({
                  type: RESET_USER
                });
                sdkDispatcher({
                  type: SDK_ERROR
                });
                // exit promise with error
                reject(errorMessage);
              };
              logger === null || logger === void 0 ? void 0 : (_logger$info8 = logger.info) === null || _logger$info8 === void 0 ? void 0 : _logger$info8.call(logger, "SendbirdProvider | useConnect/setupConnection/connect connecting using ".concat(accessToken !== null && accessToken !== void 0 ? accessToken : userId));
              newSdk.connect(userId, accessToken).then(function (res) {
                return connectCbSucess(res);
              }).catch(function (err) {
                return connectCbError(err);
              });
            } else {
              var _logger$error3;
              var errorMessage = getMissingParamError({
                userId: userId,
                appId: appId
              });
              sdkDispatcher({
                type: SDK_ERROR
              });
              logger === null || logger === void 0 ? void 0 : (_logger$error3 = logger.error) === null || _logger$error3 === void 0 ? void 0 : _logger$error3.call(logger, errorMessage);
              // exit promise with error
              reject(errorMessage);
            }
          }));
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _setUpConnection.apply(this, arguments);
}
function connect(_x3) {
  return _connect.apply(this, arguments);
}
function _connect() {
  _connect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref) {
    var logger, sdkDispatcher, userDispatcher, initDashboardConfigs, userId, appId, customApiHost, customWebSocketHost, configureSession, nickname, profileUrl, accessToken, sdk;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          logger = _ref.logger, sdkDispatcher = _ref.sdkDispatcher, userDispatcher = _ref.userDispatcher, initDashboardConfigs = _ref.initDashboardConfigs, userId = _ref.userId, appId = _ref.appId, customApiHost = _ref.customApiHost, customWebSocketHost = _ref.customWebSocketHost, configureSession = _ref.configureSession, nickname = _ref.nickname, profileUrl = _ref.profileUrl, accessToken = _ref.accessToken, sdk = _ref.sdk;
          _context4.next = 3;
          return disconnectSdk({
            logger: logger,
            sdkDispatcher: sdkDispatcher,
            userDispatcher: userDispatcher,
            sdk: sdk
          });
        case 3:
          _context4.next = 5;
          return setUpConnection({
            logger: logger,
            sdkDispatcher: sdkDispatcher,
            userDispatcher: userDispatcher,
            initDashboardConfigs: initDashboardConfigs,
            userId: userId,
            appId: appId,
            customApiHost: customApiHost,
            customWebSocketHost: customWebSocketHost,
            configureSession: configureSession,
            nickname: nickname,
            profileUrl: profileUrl,
            accessToken: accessToken
          });
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _connect.apply(this, arguments);
}
function useConnect(triggerTypes, staticTypes) {
  var _logger$info;
  var userId = triggerTypes.userId,
    appId = triggerTypes.appId,
    accessToken = triggerTypes.accessToken;
  var logger = staticTypes.logger,
    nickname = staticTypes.nickname,
    profileUrl = staticTypes.profileUrl,
    configureSession = staticTypes.configureSession,
    customApiHost = staticTypes.customApiHost,
    customWebSocketHost = staticTypes.customWebSocketHost,
    sdk = staticTypes.sdk,
    sdkDispatcher = staticTypes.sdkDispatcher,
    userDispatcher = staticTypes.userDispatcher,
    initDashboardConfigs = staticTypes.initDashboardConfigs;
  logger === null || logger === void 0 ? void 0 : (_logger$info = logger.info) === null || _logger$info === void 0 ? void 0 : _logger$info.call(logger, 'SendbirdProvider | useConnect', _objectSpread2(_objectSpread2({}, triggerTypes), staticTypes));
  useEffect(function () {
    var _logger$info2;
    logger === null || logger === void 0 ? void 0 : (_logger$info2 = logger.info) === null || _logger$info2 === void 0 ? void 0 : _logger$info2.call(logger, 'SendbirdProvider | useConnect/useEffect', {
      userId: userId,
      appId: appId,
      accessToken: accessToken
    });
    try {
      connect({
        userId: userId,
        appId: appId,
        accessToken: accessToken,
        logger: logger,
        nickname: nickname,
        profileUrl: profileUrl,
        configureSession: configureSession,
        customApiHost: customApiHost,
        customWebSocketHost: customWebSocketHost,
        sdk: sdk,
        sdkDispatcher: sdkDispatcher,
        userDispatcher: userDispatcher,
        initDashboardConfigs: initDashboardConfigs
      });
    } catch (error) {
      var _logger$error;
      logger === null || logger === void 0 ? void 0 : (_logger$error = logger.error) === null || _logger$error === void 0 ? void 0 : _logger$error.call(logger, 'SendbirdProvider | useConnect/useEffect', error);
    }
  }, [userId, appId, accessToken]);
  var reconnect = useCallback(function () {
    var _logger$info3;
    logger === null || logger === void 0 ? void 0 : (_logger$info3 = logger.info) === null || _logger$info3 === void 0 ? void 0 : _logger$info3.call(logger, 'SendbirdProvider | useConnect/reconnect/useCallback', {
      sdk: sdk
    });
    try {
      connect({
        userId: userId,
        appId: appId,
        accessToken: accessToken,
        logger: logger,
        nickname: nickname,
        profileUrl: profileUrl,
        configureSession: configureSession,
        customApiHost: customApiHost,
        customWebSocketHost: customWebSocketHost,
        sdk: sdk,
        sdkDispatcher: sdkDispatcher,
        userDispatcher: userDispatcher,
        initDashboardConfigs: initDashboardConfigs
      });
    } catch (error) {
      var _logger$error2;
      logger === null || logger === void 0 ? void 0 : (_logger$error2 = logger.error) === null || _logger$error2 === void 0 ? void 0 : _logger$error2.call(logger, 'SendbirdProvider | useConnect/reconnect/useCallback', error);
    }
  }, [sdk]);
  return reconnect;
}

// Logger, pretty much explains it
// in SendbirdProvider

// const [logger, setLogger] = useState(LoggerFactory(logLevel));
var LOG_LEVELS = {
  DEBUG: 'debug',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  ALL: 'all'
};
var colorLog = function colorLog(level) {
  switch (level) {
    case LOG_LEVELS.WARNING:
      return 'color: Orange';
    case LOG_LEVELS.ERROR:
      return 'color: Red';
    default:
      return 'color: Gray';
  }
};
var printLog = function printLog(_ref) {
  var level = _ref.level,
    title = _ref.title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description; // eslint-disable-next-line no-console
  console.log("%c SendbirdUIKit | ".concat(level, " | ").concat(new Date().toISOString(), " | ").concat(title, " ").concat(description && '|'), colorLog(level), description);
};
var noop = function noop() {/* noop */};
var getDefaultLogger = function getDefaultLogger() {
  return {
    info: noop,
    error: noop,
    warning: noop
  };
};
var LoggerFactory = function LoggerFactory(lvl, customInterface) {
  var logInterface = customInterface || printLog;
  var lvlArray = Array.isArray(lvl) ? lvl : [lvl];
  var applyLog = function applyLog(lgLvl) {
    return function (title, description) {
      return logInterface({
        level: lgLvl,
        title: title,
        description: description
      });
    };
  };
  var logger = lvlArray.reduce(function (accumulator, currentLvl) {
    if (currentLvl === LOG_LEVELS.DEBUG || currentLvl === LOG_LEVELS.ALL) {
      return _objectSpread2(_objectSpread2({}, accumulator), {}, {
        info: applyLog(LOG_LEVELS.INFO),
        error: applyLog(LOG_LEVELS.ERROR),
        warning: applyLog(LOG_LEVELS.WARNING)
      });
    }
    if (currentLvl === LOG_LEVELS.INFO) {
      return _objectSpread2(_objectSpread2({}, accumulator), {}, {
        info: applyLog(LOG_LEVELS.INFO)
      });
    }
    if (currentLvl === LOG_LEVELS.ERROR) {
      return _objectSpread2(_objectSpread2({}, accumulator), {}, {
        error: applyLog(LOG_LEVELS.ERROR)
      });
    }
    if (currentLvl === LOG_LEVELS.WARNING) {
      return _objectSpread2(_objectSpread2({}, accumulator), {}, {
        warning: applyLog(LOG_LEVELS.WARNING)
      });
    }
    return _objectSpread2({}, accumulator);
  }, getDefaultLogger());
  return logger;
};

// TODO: Make this to hook, useLogger

// https://davidwalsh.name/pubsub-javascript
// we use pubsub to sync events between multiple components(example - ChannelList, Channel)
// for example, if customer sends a message from their custom component
// without pubsub,we would not be able to listen to it
// in our ChannelList or Conversation

var pubSubFactory = function pubSubFactory() {
  var topics = {};
  var hOP = topics.hasOwnProperty;
  return {
    __getTopics: function __getTopics() {
      return topics;
    },
    subscribe: function subscribe(topic, listener) {
      // Create the topic's object if not yet created
      if (!hOP.call(topics, topic)) {
        topics[topic] = [];
      }

      // Add the listener to queue
      var index = topics[topic].push(listener) - 1;

      // Provide handle back for removal of topic
      return {
        remove: function remove() {
          delete topics[topic][index];
        }
      };
    },
    publish: function publish(topic, info) {
      // If the topic doesn't exist, or there's no listeners in queue, just leave
      if (!hOP.call(topics, topic)) {
        return;
      }

      // Cycle through topics queue, fire!
      topics[topic].forEach(function (item) {
        item(info !== undefined ? info : {});
      });
    }
  };
};

/* eslint-disable default-param-last */
function useAppendDomNode() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rootSelector = arguments.length > 1 ? arguments[1] : undefined;
  useEffect(function () {
    var root = document.querySelector(rootSelector);
    ids.forEach(function (id) {
      var elem = document.createElement('div');
      elem.setAttribute('id', id);
      root.appendChild(elem);
    });
    return function () {
      ids.forEach(function (id) {
        var target = document.getElementById(id);
        if (target) {
          root.removeChild(target);
        }
      });
    };
  }, []);
}
var VoiceMessageProvider = function VoiceMessageProvider(_ref) {
  var children = _ref.children,
    _ref$isVoiceMessageEn = _ref.isVoiceMessageEnabled,
    isVoiceMessageEnabled = _ref$isVoiceMessageEn === void 0 ? true : _ref$isVoiceMessageEn;
  if (!isVoiceMessageEnabled) {
    return /*#__PURE__*/React__default.createElement(VoicePlayerProvider, null, children);
  }
  return /*#__PURE__*/React__default.createElement(VoiceRecorderProvider, null, /*#__PURE__*/React__default.createElement(VoicePlayerProvider, null, children));
};
function uikitConfigMapper(_ref) {
  var _uikitOptions$common$, _uikitOptions$common, _uikitOptions$groupCh, _uikitOptions$groupCh2, _uikitOptions$groupCh3, _uikitOptions$groupCh4, _uikitOptions$groupCh5, _uikitOptions$groupCh6, _uikitOptions$groupCh7, _uikitOptions$groupCh8, _uikitOptions$groupCh9, _uikitOptions$groupCh10, _uikitOptions$groupCh11, _uikitOptions$groupCh12, _uikitOptions$groupCh13, _uikitOptions$groupCh14, _uikitOptions$groupCh15, _uikitOptions$groupCh16, _uikitOptions$groupCh17, _uikitOptions$groupCh18, _uikitOptions$groupCh19, _uikitOptions$openCha, _uikitOptions$openCha2, _uikitOptions$openCha3;
  var legacyConfig = _ref.legacyConfig,
    _ref$uikitOptions = _ref.uikitOptions,
    uikitOptions = _ref$uikitOptions === void 0 ? {} : _ref$uikitOptions;
  var replyType = legacyConfig.replyType,
    isMentionEnabled = legacyConfig.isMentionEnabled,
    isReactionEnabled = legacyConfig.isReactionEnabled,
    disableUserProfile = legacyConfig.disableUserProfile,
    isVoiceMessageEnabled = legacyConfig.isVoiceMessageEnabled,
    isTypingIndicatorEnabledOnChannelList = legacyConfig.isTypingIndicatorEnabledOnChannelList,
    isMessageReceiptStatusEnabledOnChannelList = legacyConfig.isMessageReceiptStatusEnabledOnChannelList,
    showSearchIcon = legacyConfig.showSearchIcon;
  return {
    common: {
      enableUsingDefaultUserProfile: (_uikitOptions$common$ = (_uikitOptions$common = uikitOptions.common) === null || _uikitOptions$common === void 0 ? void 0 : _uikitOptions$common.enableUsingDefaultUserProfile) !== null && _uikitOptions$common$ !== void 0 ? _uikitOptions$common$ : typeof disableUserProfile === 'boolean' ? !disableUserProfile : undefined
    },
    groupChannel: {
      enableOgtag: (_uikitOptions$groupCh = uikitOptions.groupChannel) === null || _uikitOptions$groupCh === void 0 ? void 0 : _uikitOptions$groupCh.enableOgtag,
      enableMention: (_uikitOptions$groupCh2 = (_uikitOptions$groupCh3 = uikitOptions.groupChannel) === null || _uikitOptions$groupCh3 === void 0 ? void 0 : _uikitOptions$groupCh3.enableMention) !== null && _uikitOptions$groupCh2 !== void 0 ? _uikitOptions$groupCh2 : isMentionEnabled,
      enableReactions: (_uikitOptions$groupCh4 = (_uikitOptions$groupCh5 = uikitOptions.groupChannel) === null || _uikitOptions$groupCh5 === void 0 ? void 0 : _uikitOptions$groupCh5.enableReactions) !== null && _uikitOptions$groupCh4 !== void 0 ? _uikitOptions$groupCh4 : isReactionEnabled,
      enableTypingIndicator: (_uikitOptions$groupCh6 = uikitOptions.groupChannel) === null || _uikitOptions$groupCh6 === void 0 ? void 0 : _uikitOptions$groupCh6.enableTypingIndicator,
      enableVoiceMessage: (_uikitOptions$groupCh7 = (_uikitOptions$groupCh8 = uikitOptions.groupChannel) === null || _uikitOptions$groupCh8 === void 0 ? void 0 : _uikitOptions$groupCh8.enableVoiceMessage) !== null && _uikitOptions$groupCh7 !== void 0 ? _uikitOptions$groupCh7 : isVoiceMessageEnabled,
      replyType: (_uikitOptions$groupCh9 = (_uikitOptions$groupCh10 = uikitOptions.groupChannel) === null || _uikitOptions$groupCh10 === void 0 ? void 0 : _uikitOptions$groupCh10.replyType) !== null && _uikitOptions$groupCh9 !== void 0 ? _uikitOptions$groupCh9 : replyType != null ? getCaseResolvedReplyType(replyType).lowerCase : undefined,
      threadReplySelectType: (_uikitOptions$groupCh11 = uikitOptions.groupChannel) === null || _uikitOptions$groupCh11 === void 0 ? void 0 : _uikitOptions$groupCh11.threadReplySelectType,
      input: {
        enableDocument: (_uikitOptions$groupCh12 = uikitOptions.groupChannel) === null || _uikitOptions$groupCh12 === void 0 ? void 0 : (_uikitOptions$groupCh13 = _uikitOptions$groupCh12.input) === null || _uikitOptions$groupCh13 === void 0 ? void 0 : _uikitOptions$groupCh13.enableDocument
      }
    },
    groupChannelList: {
      enableTypingIndicator: (_uikitOptions$groupCh14 = (_uikitOptions$groupCh15 = uikitOptions.groupChannelList) === null || _uikitOptions$groupCh15 === void 0 ? void 0 : _uikitOptions$groupCh15.enableTypingIndicator) !== null && _uikitOptions$groupCh14 !== void 0 ? _uikitOptions$groupCh14 : isTypingIndicatorEnabledOnChannelList,
      enableMessageReceiptStatus: (_uikitOptions$groupCh16 = (_uikitOptions$groupCh17 = uikitOptions.groupChannelList) === null || _uikitOptions$groupCh17 === void 0 ? void 0 : _uikitOptions$groupCh17.enableMessageReceiptStatus) !== null && _uikitOptions$groupCh16 !== void 0 ? _uikitOptions$groupCh16 : isMessageReceiptStatusEnabledOnChannelList
    },
    groupChannelSettings: {
      enableMessageSearch: (_uikitOptions$groupCh18 = (_uikitOptions$groupCh19 = uikitOptions.groupChannelSettings) === null || _uikitOptions$groupCh19 === void 0 ? void 0 : _uikitOptions$groupCh19.enableMessageSearch) !== null && _uikitOptions$groupCh18 !== void 0 ? _uikitOptions$groupCh18 : showSearchIcon
    },
    openChannel: {
      enableOgtag: (_uikitOptions$openCha = uikitOptions.openChannel) === null || _uikitOptions$openCha === void 0 ? void 0 : _uikitOptions$openCha.enableOgtag,
      input: {
        enableDocument: (_uikitOptions$openCha2 = uikitOptions.openChannel) === null || _uikitOptions$openCha2 === void 0 ? void 0 : (_uikitOptions$openCha3 = _uikitOptions$openCha2.input) === null || _uikitOptions$openCha3 === void 0 ? void 0 : _uikitOptions$openCha3.enableDocument
      }
    }
  };
}
var TIMEOUT = 2000;

/*
  * This is a factory function that returns a scheduler.
  * The scheduler is a queue that calls the callback function on intervals.
  * If interval is empty, the callback function is called immediately.
  * If interval is not empty, the callback function is called after the interval.
*/
function schedulerFactory(_ref) {
  var logger = _ref.logger,
    timeout = _ref.timeout,
    cb = _ref.cb;
  var queue = [];
  var interval = null;
  var push = function push(channel) {
    var channelPresent = queue.find(function (c) {
      return c.url === channel.url;
    });
    if (!channelPresent) {
      queue.push(channel);
    } else {
      logger.info('Channel: Mark as read already in queue', {
        channel: channel
      });
    }
    // start the interval if it's not already running
    if (interval) {
      return;
    }
    var item = queue.shift();
    if (item) {
      cb(item);
    }
    interval = setInterval(function () {
      if (queue.length === 0 && interval) {
        clearInterval(interval);
        interval = null;
        return;
      }
      var item = queue.shift();
      if (item) {
        cb(item);
      }
    }, timeout || TIMEOUT);
  };
  var clear = function clear() {
    queue = [];
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  };
  return {
    push: push,
    clear: clear,
    getQueue: function getQueue() {
      return queue;
    }
  };
}

// this hook accepts a callback to run component is unmounted
function useUnmount(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  useLayoutEffect(function () {
    return function () {
      callback();
    };
  }, deps);
}
function useMarkAsReadScheduler(_ref, _ref2) {
  var isConnected = _ref.isConnected;
  var logger = _ref2.logger;
  var markAsReadScheduler = useMemo(function () {
    return schedulerFactory({
      logger: logger,
      cb: function cb(channel) {
        try {
          channel.markAsRead();
        } catch (error) {
          logger.warning('Channel: Mark as delivered failed', {
            channel: channel,
            error: error
          });
        }
      }
    });
  }, []);
  useEffect(function () {
    // for simplicity, we clear the queue when the connection is lost
    if (!isConnected) {
      markAsReadScheduler.clear();
    }
  }, [isConnected]);
  useUnmount(function () {
    markAsReadScheduler.clear();
  });
  return markAsReadScheduler;
}
function useMarkAsDeliveredScheduler(_ref, _ref2) {
  var isConnected = _ref.isConnected;
  var logger = _ref2.logger;
  var markAsDeliveredScheduler = useMemo(function () {
    return schedulerFactory({
      logger: logger,
      cb: function cb(channel) {
        try {
          channel.markAsDelivered();
        } catch (error) {
          logger.warning('Channel: Mark as delivered failed', {
            channel: channel,
            error: error
          });
        }
      }
    });
  }, []);
  useEffect(function () {
    // for simplicity, we clear the queue when the connection is lost
    if (!isConnected) {
      markAsDeliveredScheduler.clear();
    }
  }, [isConnected]);
  useUnmount(function () {
    markAsDeliveredScheduler.clear();
  });
  return markAsDeliveredScheduler;
}
function Sendbird(props) {
  var localConfigs = uikitConfigMapper({
    legacyConfig: {
      replyType: props.replyType,
      isMentionEnabled: props.isMentionEnabled,
      isReactionEnabled: props.isReactionEnabled,
      disableUserProfile: props.disableUserProfile,
      isVoiceMessageEnabled: props.isVoiceMessageEnabled,
      isTypingIndicatorEnabledOnChannelList: props.isTypingIndicatorEnabledOnChannelList,
      isMessageReceiptStatusEnabledOnChannelList: props.isMessageReceiptStatusEnabledOnChannelList,
      showSearchIcon: props.showSearchIcon
    },
    uikitOptions: props.uikitOptions
  });
  return /*#__PURE__*/React__default.createElement(UIKitConfigProvider, {
    localConfigs: {
      common: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.common,
      groupChannel: {
        channel: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.groupChannel,
        channelList: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.groupChannelList,
        setting: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.groupChannelSettings
      },
      openChannel: {
        channel: localConfigs === null || localConfigs === void 0 ? void 0 : localConfigs.openChannel
      }
    }
  }, /*#__PURE__*/React__default.createElement(SendbirdSDK, props));
}
var SendbirdSDK = function SendbirdSDK(_ref) {
  var appId = _ref.appId,
    userId = _ref.userId,
    children = _ref.children,
    _ref$accessToken = _ref.accessToken,
    accessToken = _ref$accessToken === void 0 ? '' : _ref$accessToken,
    _ref$customApiHost = _ref.customApiHost,
    customApiHost = _ref$customApiHost === void 0 ? '' : _ref$customApiHost,
    _ref$customWebSocketH = _ref.customWebSocketHost,
    customWebSocketHost = _ref$customWebSocketH === void 0 ? '' : _ref$customWebSocketH,
    _ref$configureSession = _ref.configureSession,
    configureSession = _ref$configureSession === void 0 ? null : _ref$configureSession,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$nickname = _ref.nickname,
    nickname = _ref$nickname === void 0 ? '' : _ref$nickname,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? null : _ref$colorSet,
    _ref$stringSet = _ref.stringSet,
    stringSet = _ref$stringSet === void 0 ? null : _ref$stringSet,
    _ref$dateLocale = _ref.dateLocale,
    dateLocale = _ref$dateLocale === void 0 ? null : _ref$dateLocale,
    _ref$profileUrl = _ref.profileUrl,
    profileUrl = _ref$profileUrl === void 0 ? '' : _ref$profileUrl,
    _ref$voiceRecord = _ref.voiceRecord,
    voiceRecord = _ref$voiceRecord === void 0 ? {
      maxRecordingTime: VOICE_RECORDER_DEFAULT_MAX,
      minRecordingTime: VOICE_RECORDER_DEFAULT_MIN
    } : _ref$voiceRecord,
    _ref$userListQuery = _ref.userListQuery,
    userListQuery = _ref$userListQuery === void 0 ? null : _ref$userListQuery,
    _ref$imageCompression = _ref.imageCompression,
    imageCompression = _ref$imageCompression === void 0 ? {} : _ref$imageCompression,
    _ref$allowProfileEdit = _ref.allowProfileEdit,
    allowProfileEdit = _ref$allowProfileEdit === void 0 ? false : _ref$allowProfileEdit,
    _ref$disableMarkAsDel = _ref.disableMarkAsDelivered,
    disableMarkAsDelivered = _ref$disableMarkAsDel === void 0 ? false : _ref$disableMarkAsDel,
    _ref$renderUserProfil = _ref.renderUserProfile,
    renderUserProfile = _ref$renderUserProfil === void 0 ? null : _ref$renderUserProfil,
    _ref$onUserProfileMes = _ref.onUserProfileMessage,
    onUserProfileMessage = _ref$onUserProfileMes === void 0 ? null : _ref$onUserProfileMes,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? false : _ref$breakpoint;
  var _config$logLevel = config.logLevel,
    logLevel = _config$logLevel === void 0 ? '' : _config$logLevel,
    _config$userMention = config.userMention,
    userMention = _config$userMention === void 0 ? {} : _config$userMention,
    _config$isREMUnitEnab = config.isREMUnitEnabled,
    isREMUnitEnabled = _config$isREMUnitEnab === void 0 ? false : _config$isREMUnitEnab;
  var _useState3 = useState(LoggerFactory(logLevel)),
    _useState4 = _slicedToArray(_useState3, 2),
    logger = _useState4[0],
    setLogger = _useState4[1];
  var _useState5 = useState(pubSubFactory()),
    _useState6 = _slicedToArray(_useState5, 1),
    pubSub = _useState6[0];
  var _useReducer = useReducer(reducer$1, initialState$1),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    sdkStore = _useReducer2[0],
    sdkDispatcher = _useReducer2[1];
  var _useReducer3 = useReducer(reducer, initialState),
    _useReducer4 = _slicedToArray(_useReducer3, 2),
    userStore = _useReducer4[0],
    userDispatcher = _useReducer4[1];
  var _useUIKitConfig = useUIKitConfig(),
    configs = _useUIKitConfig.configs,
    configsWithAppAttr = _useUIKitConfig.configsWithAppAttr,
    initDashboardConfigs = _useUIKitConfig.initDashboardConfigs;
  var sdkInitialized = sdkStore.initialized;
  var sdk = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.sdk;
  useTheme(colorSet);
  var reconnect = useConnect({
    appId: appId,
    userId: userId,
    accessToken: accessToken
  }, {
    logger: logger,
    nickname: nickname,
    profileUrl: profileUrl,
    configureSession: configureSession,
    customApiHost: customApiHost,
    customWebSocketHost: customWebSocketHost,
    sdk: sdk,
    sdkDispatcher: sdkDispatcher,
    userDispatcher: userDispatcher,
    initDashboardConfigs: initDashboardConfigs
  });
  useUnmount(function () {
    if (typeof sdk.disconnect === 'function') {
      disconnectSdk({
        logger: logger,
        sdkDispatcher: sdkDispatcher,
        userDispatcher: userDispatcher,
        sdk: sdk
      });
    }
  }, [sdk.disconnect]);

  // to create a pubsub to communicate between parent and child
  useEffect(function () {
    setLogger(LoggerFactory(logLevel));
  }, [logLevel]);
  useAppendDomNode(['sendbird-modal-root', 'sendbird-dropdown-portal', 'sendbird-emoji-list-portal'], 'body');

  // should move to reducer
  var _useState7 = useState(theme),
    _useState8 = _slicedToArray(_useState7, 2),
    currenttheme = _useState8[0],
    setCurrenttheme = _useState8[1];
  useEffect(function () {
    setCurrenttheme(theme);
  }, [theme]);
  useEffect(function () {
    var body = document.querySelector('body');
    body.classList.remove('sendbird-experimental__rem__units');
    if (isREMUnitEnabled) {
      body.classList.add('sendbird-experimental__rem__units');
    }
  }, [isREMUnitEnabled]);
  // add-remove theme from body
  useEffect(function () {
    logger.info('Setup theme', "Theme: ".concat(currenttheme));
    try {
      var body = document.querySelector('body');
      body.classList.remove('sendbird-theme--light');
      body.classList.remove('sendbird-theme--dark');
      body.classList.add("sendbird-theme--".concat(currenttheme || 'light'));
      logger.info('Finish setup theme');
      // eslint-disable-next-line no-empty
    } catch (e) {
      logger.warning('Setup theme failed', "".concat(e));
    }
    return function () {
      try {
        var _body = document.querySelector('body');
        _body.classList.remove('sendbird-theme--light');
        _body.classList.remove('sendbird-theme--dark');
        // eslint-disable-next-line no-empty
      } catch (_unused) {}
    };
  }, [currenttheme]);
  var isOnline = useConnectionStatus(sdkStore.sdk, logger);
  var markAsReadScheduler = useMarkAsReadScheduler({
    isConnected: isOnline
  }, {
    logger: logger
  });
  var markAsDeliveredScheduler = useMarkAsDeliveredScheduler({
    isConnected: isOnline
  }, {
    logger: logger
  });
  var localeStringSet = React__default.useMemo(function () {
    if (!stringSet) {
      return getStringSet('en');
    }
    return _objectSpread2(_objectSpread2({}, getStringSet('en')), stringSet);
  }, [stringSet]);
  return /*#__PURE__*/React__default.createElement(SendbirdSdkContext.Provider, {
    value: {
      stores: {
        sdkStore: sdkStore,
        userStore: userStore
      },
      dispatchers: {
        sdkDispatcher: sdkDispatcher,
        userDispatcher: userDispatcher,
        reconnect: reconnect
      },
      config: {
        disableMarkAsDelivered: disableMarkAsDelivered,
        renderUserProfile: renderUserProfile,
        onUserProfileMessage: onUserProfileMessage,
        allowProfileEdit: allowProfileEdit,
        isOnline: isOnline,
        userId: userId,
        appId: appId,
        accessToken: accessToken,
        theme: currenttheme,
        setCurrenttheme: setCurrenttheme,
        userListQuery: userListQuery,
        logger: logger,
        pubSub: pubSub,
        imageCompression: _objectSpread2({
          compressionRate: 0.7
        }, imageCompression),
        voiceRecord: voiceRecord,
        userMention: {
          maxMentionCount: (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount) || 10,
          maxSuggestionCount: (userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount) || 15
        },
        markAsReadScheduler: markAsReadScheduler,
        markAsDeliveredScheduler: markAsDeliveredScheduler,
        // From UIKitConfigProvider.localConfigs
        disableUserProfile: !configs.common.enableUsingDefaultUserProfile,
        isReactionEnabled: sdkInitialized && configsWithAppAttr(sdk).groupChannel.channel.enableReactions,
        isMentionEnabled: configs.groupChannel.channel.enableMention,
        isVoiceMessageEnabled: configs.groupChannel.channel.enableVoiceMessage,
        replyType: getCaseResolvedReplyType(configs.groupChannel.channel.replyType).upperCase,
        isTypingIndicatorEnabledOnChannelList: configs.groupChannel.channelList.enableTypingIndicator,
        isMessageReceiptStatusEnabledOnChannelList: configs.groupChannel.channelList.enableMessageReceiptStatus,
        showSearchIcon: sdkInitialized && configsWithAppAttr(sdk).groupChannel.setting.enableMessageSearch,
        // Remote configs set from dashboard by UIKit feature configuration
        groupChannel: {
          enableOgtag: sdkInitialized && configsWithAppAttr(sdk).groupChannel.channel.enableOgtag,
          enableTypingIndicator: configs.groupChannel.channel.enableTypingIndicator,
          enableDocument: configs.groupChannel.channel.input.enableDocument,
          threadReplySelectType: getCaseResolvedThreadReplySelectType(configs.groupChannel.channel.threadReplySelectType).upperCase
        },
        openChannel: {
          enableOgtag: sdkInitialized && configsWithAppAttr(sdk).openChannel.channel.enableOgtag,
          enableDocument: configs.openChannel.channel.input.enableDocument
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(MediaQueryProvider, {
    logger: logger,
    breakpoint: breakpoint
  }, /*#__PURE__*/React__default.createElement(LocalizationProvider, {
    stringSet: localeStringSet,
    dateLocale: dateLocale
  }, /*#__PURE__*/React__default.createElement(VoiceMessageProvider, {
    isVoiceMessageEnabled: configs.groupChannel.channel.enableVoiceMessage
  }, children))));
};
export { Sendbird as default };